<script>
export default {
  name: "Services"
};
</script>

<template>
  <div>
    <!--START SERVICES-->
    <section class="section bg-light" id="services">
      <div class="container">
        <div class="row">
          <div class="col-lg-8 offset-lg-2">
            <h1 class="section-title text-center">Our Services</h1>
            <div class="section-title-border margin-t-20"></div>
            <p
              class="section-subtitle text-muted text-center padding-t-30 font-secondary"
            >
              We craft digital, graphic and dimensional thinking, to create
              category leading brand experiences that have meaning and add a
              value for our clients.
            </p>
          </div>
        </div>
        <div class="row margin-t-30">
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-diamond text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Web Illustrations</h4>
                  <p class="pt-2 text-muted">
                    We design your own unique look for your website based on
                    your brand identity. You can pick among the designs.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-display1 text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Modern Websites</h4>
                  <p class="pt-2 text-muted">
                    We can make your website on WordPress, the world's leading
                    platform, or build it with your very own cms.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-phone text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Web Apps</h4>
                  <p class="pt-2 text-muted">
                    Enjoy fully reponsive web applications, that load blazingly
                    fast and are accessible from every device.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="row">
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-cart text-custom"></i>
                <div class="media-body ml-4">
                  <h4>E-commerce sites</h4>
                  <p class="pt-2 text-muted">
                    We build your e-commerce site on Open Cart or WooCommerce.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-graph1 text-custom"></i>
                <div class="media-body ml-4">
                  <h4>SEO</h4>
                  <p class="pt-2 text-muted">
                    Are you looking to boost your sales? Is Google listing your
                    site too low? We can help with that.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-photo text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Beautiful Banners</h4>
                  <p class="pt-2 text-muted">
                    GIF animations or smooth HTML5 banners on any resolution,
                    ready to be embeded to your website.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-signal text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Impressive Streams</h4>
                  <p class="pt-2 text-muted">
                    We can help stream your event on High Definition on any
                    platform. Single or multiple cameras.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-film text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Professional Video</h4>
                  <p class="pt-2 text-muted">
                    We can produce a professional video for your website or your
                    social media.
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="col-lg-4 margin-t-20">
            <div class="services-box">
              <div class="media">
                <i class="pe-7s-tools text-custom"></i>
                <div class="media-body ml-4">
                  <h4>Amazing Support</h4>
                  <p class="pt-2 text-muted">
                    Effortless system administration. We do the hard work of
                    setting everything up for you. Your server, your domain and
                    your mailbox.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
    <!--START SERVICES-->

    <!--START WEBSITE-DESCRIPTION-->
    <section
      class="bg-web-desc"
      :style="{
        'background-image': 'url(' + require('@/assets/images/img-1.jpg') + ')',
        'background-size': 'cover',
        'background-position': 'center',
        'padding-top': '80px',
        'padding-bottom': '80px',
        position: 'relative'
      }"
    >
      <div class="bg-overlay"></div>
      <div class="container">
        <div class="row">
          <div class="col-lg-12 text-center">
            <h2 class="text-white">Build your dream website today</h2>
            <p class="padding-t-15 home-desc mx-auto">
              Create your professional looking image for your "internet
              audience" and benefit instantly with measurable results.
            </p>
            <a
              href="#"
              v-scroll-to="'#contact'"
              class="btn btn-bg-white margin-t-30"
              >Contact Us</a
            >
          </div>
        </div>
      </div>
    </section>
    <!--END WEBSITE-DESCRIPTION-->
  </div>
</template>